import nextPkg from 'next/package.json';
import pkg from '../../package.json';

export const NEXT_CLOUDINARY_ANALYTICS_ID = 'V';
export const NEXT_CLOUDINARY_VERSION = pkg.version;
export const NEXT_VERSION = nextPkg.version;